// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import Chart from "react-apexcharts/dist/react-apexcharts.min.js";
// import { getDashboardExcel } from "stores";

// function DashboardDisbursement() {
//   const dispatch = useDispatch();
//   const currentYear = new Date().getFullYear();

//   const generateInitialYears = () => {
//     const startYear = 2022;
//     const years = [];
//     for (let y = currentYear; y >= startYear; y--) {
//       years.push(y);
//     }
//     return years.sort((a, b) => a - b);
//   };

//   // State Utama Filter & Data
//   const [selectedTahun, setSelectedTahun] = useState(currentYear);
//   const [selectedClient, setSelectedClient] = useState("All");
//   const [listTahun, setListTahun] = useState(generateInitialYears());

//   // State untuk menyimpan data series Chart
//   const [chartSeries, setChartSeries] = useState([]);
//   const [summaryData, setSummaryData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [clientSummaryList, setClientSummaryList] = useState([]);

//   // Master Data Client & Bulan
//   const listClientMaster = [
//     "BPD KALTIMTARA",
//     "BPD KALTENG",
//     "BPD KALSEL",
//     "BPD SULUTGO",
//     "BPD KALBAR",
//   ];
//   const monthsName = [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "Mei",
//     "Jun",
//     "Jul",
//     "Agu",
//     "Sep",
//     "Okt",
//     "Nov",
//     "Des",
//   ];

//   useEffect(() => {
//     setLoading(true);

//     getDashboardExcel(dispatch, {
//       tahun: selectedTahun,
//       client: selectedClient,
//       page: 1,
//       limit: 1000,
//     })
//       .then((response) => {
//         console.log("RAW DATA DARI BACKEND:", response);

//         if (response && response.data) {
//           if (response.summary) {
//             setSummaryData(response.summary);
//           }

//           // Sinkronisasi dropdown list tahun
//           const availableYears = response.data.map((item) =>
//             Number(item.tahun),
//           );
//           const mergedYears = [...listTahun, ...availableYears];
//           const uniqueYears = [...new Set(mergedYears)].sort((a, b) => a - b);
//           if (uniqueYears.length > 0) setListTahun(uniqueYears);

//           // ====================================================================
//           // LOGIKA BARU: KALKULASI BREAKDOWN SUMMARY PER CLIENT DARI DATABASE
//           // ====================================================================
//           const clientsToProcess =
//             selectedClient === "All" ? listClientMaster : [selectedClient];

//           const breakdownResult = clientsToProcess.map((bpdName) => {
//             const bpdData = response.data.filter(
//               (item) => item.client === bpdName,
//             );

//             // Hitung total akumulasi murni setahun dari data MongoDB
//             const totalDisbursement = bpdData.reduce(
//               (sum, item) => sum + Number(item.disbursement || 0),
//               0,
//             );
//             const totalTargetSales = bpdData.reduce(
//               (sum, item) => sum + Number(item.target_sales || 0),
//               0,
//             );

//             // Rumus persentase grand total mengikuti standard Excel (Total Realisasi / Total Target)
//             const avgPercentage =
//               totalTargetSales > 0
//                 ? (totalDisbursement / totalTargetSales) * 100
//                 : 0;

//             return {
//               client: bpdName,
//               totalDisbursement,
//               totalTargetSales,
//               avgPercentage,
//             };
//           });

//           setClientSummaryList(breakdownResult);
//           // ====================================================================

//           // Logika pembentukan grafik area Anda sebelumnya
//           const finalSeries = [];
//           if (selectedClient === "All") {
//             const totalAllArray = Array(12).fill(0);
//             response.data.forEach((item) => {
//               const mIdx = parseInt(item.bulan, 10) - 1;
//               if (mIdx >= 0 && mIdx < 12) {
//                 totalAllArray[mIdx] += Number(item.disbursement || 0);
//               }
//             });
//             finalSeries.push({ name: "TOTAL ALL", data: totalAllArray });

//             listClientMaster.forEach((bpd) => {
//               const bpdArray = Array(12).fill(0);
//               const bpdFilteredData = response.data.filter(
//                 (item) => item.client === bpd,
//               );
//               bpdFilteredData.forEach((item) => {
//                 const mIdx = parseInt(item.bulan, 10) - 1;
//                 if (mIdx >= 0 && mIdx < 12) {
//                   bpdArray[mIdx] = Number(item.disbursement || 0);
//                 }
//               });
//               finalSeries.push({ name: bpd, data: bpdArray });
//             });
//           } else {
//             const singleBpdArray = Array(12).fill(0);
//             response.data.forEach((item) => {
//               const mIdx = parseInt(item.bulan, 10) - 1;
//               if (mIdx >= 0 && mIdx < 12) {
//                 singleBpdArray[mIdx] = Number(item.disbursement || 0);
//               }
//             });
//             finalSeries.push({
//               name: `Disbursement (${selectedClient})`,
//               data: singleBpdArray,
//             });
//           }
//           setChartSeries(finalSeries);
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//         setChartSeries([]);
//         setClientSummaryList([]);
//       })
//       .finally(() => setLoading(false));
//   }, [selectedTahun, selectedClient, dispatch]);

//   const formatIDR = (val) => "Rp " + Number(val || 0).toLocaleString("id-ID");

//   // Konfigurasi Khusus Multi-Series Area Chart
//   const chartOptions = {
//     chart: {
//       id: "area-disbursement-chart",
//       type: "area", // Kunci utama untuk set tipe global ke Area
//       toolbar: { show: true },
//       zoom: { enabled: true },
//     },
//     xaxis: {
//       categories: monthsName,
//       title: { text: "Bulan" },
//     },
//     yaxis: {
//       title: { text: "Nominal Disbursement (IDR)" },
//       labels: {
//         formatter: (value) => {
//           if (value >= 1e12) return (value / 1e12).toFixed(1) + " T";
//           if (value >= 1e9) return (value / 1e9).toFixed(1) + " Miliar";
//           if (value >= 1e6) return (value / 1e6).toFixed(1) + " Jt";
//           return value;
//         },
//       },
//     },
//     // Mengatur opacity fill area di bawah garis agar transparan elegan (tidak saling menutupi)
//     fill: {
//       type: "vertical",
//       opacity:
//         selectedClient === "All" ? [0.05, 0.2, 0.2, 0.2, 0.2, 0.2] : [0.3],
//     },
//     // Ketebalan garis tepi kurva: TOTAL ALL dibuat paling dominan (5), sisanya standar (2.5)
//     stroke: {
//       width: selectedClient === "All" ? [5, 2.5, 2.5, 2.5, 2.5, 2.5] : [3.5],
//       curve: "smooth",
//     },
//     tooltip: {
//       shared: true,
//       intersect: false,
//       y: {
//         formatter: (val) => formatIDR(val),
//       },
//     },
//     // Palet warna kontras yang estetik saat menumpuk
//     colors: ["#20c997", "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"],
//     dataLabels: { enabled: false },
//     legend: { position: "top" },
//   };

//   return (
//     <div style={{ padding: "24px", background: "#fff", borderRadius: "8px" }}>
//       <h2 style={{ fontWeight: "bold", textAlign: "center" }}>
//         Dashboard Disbursement All BPD - Tahun {selectedTahun}
//       </h2>
//       <hr
//         style={{
//           border: "none",
//           height: "3px",
//           backgroundColor: "black",
//           width: "950px",
//           margin: "20px auto",
//         }}
//       />
//       {/* SECTION DROPDOWN FILTER */}
//       <div style={{ display: "flex", gap: "16px", marginBottom: "24px" }}>
//         <div>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "8px",
//               fontWeight: "bold",
//             }}
//           >
//             Tahun:
//           </label>
//           <select
//             value={selectedTahun}
//             onChange={(e) => setSelectedTahun(Number(e.target.value))}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "4px",
//               border: "1px solid #ccc",
//               cursor: "pointer",
//             }}
//           >
//             {listTahun.map((th) => (
//               <option key={th} value={th}>
//                 {th}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "8px",
//               fontWeight: "bold",
//             }}
//           >
//             Client:
//           </label>
//           <select
//             value={selectedClient}
//             onChange={(e) => setSelectedClient(e.target.value)}
//             style={{
//               padding: "8px 12px",
//               borderRadius: "4px",
//               border: "1px solid #ccc",
//               minWidth: "200px",
//               cursor: "pointer",
//             }}
//           >
//             {["All", ...listClientMaster].map((cli) => (
//               <option key={cli} value={cli}>
//                 {cli}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* SUMMARY BANNER CARD */}
//       {/* STATS SUMMARY BANNER DENGAN AUTOMATIC BREAKDOWN PER CLIENT (100% RESPONSIVE) */}
//       {summaryData && clientSummaryList.length > 0 && (
//         <div style={{ marginBottom: "32px", width: "100%" }}>
//           {/* 1. KOTAK GRAND TOTAL UTAMA (ANTI-BREAK DI HP, ADAPTIF DI LAPTOP) */}
//           <div
//             style={{
//               display: "grid",
//               // Menggunakan auto-fit dan minmax agar otomatis bungkus ke bawah jika lebar layar di bawah 280px per card
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "20px",
//               marginBottom: "24px",
//               width: "100%",
//             }}
//           >
//             {/* CARD 1: DISBURSEMENT */}
//             <div
//               style={{
//                 background: "#f8f9fa",
//                 padding: "16px",
//                 borderRadius: "6px",
//                 borderRight: "6px solid #007bff",
//                 boxSizing: "border-box", // Diperbaiki dari boxShaping
//                 boxShadow:
//                   "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
//               }}
//             >
//               <span
//                 style={{
//                   display: "block",
//                   fontSize: "12px",
//                   color: "#6c757d",
//                   fontWeight: "600",
//                   letterSpacing: "0.5px",
//                 }}
//               >
//                 GRAND TOTAL DISBURSEMENT
//               </span>
//               <h3
//                 style={{
//                   margin: "8px 0 0 0",
//                   color: "#007bff",
//                   fontSize: "calc(14px + 0.6vw)",
//                   wordBreak: "break-all",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {formatIDR(summaryData.totalDisbursement)}
//               </h3>
//             </div>

//             {/* CARD 2: TARGET SALES */}
//             <div
//               style={{
//                 background: "#f8f9fa",
//                 padding: "16px",
//                 borderRadius: "6px",
//                 borderRight: "6px solid #28a745",
//                 boxSizing: "border-box", // Diperbaiki dari boxShaping
//                 boxShadow:
//                   "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
//               }}
//             >
//               <span
//                 style={{
//                   display: "block",
//                   fontSize: "12px",
//                   color: "#6c757d",
//                   fontWeight: "600",
//                   letterSpacing: "0.5px",
//                   //   textAlign: "center",
//                 }}
//               >
//                 GRAND TOTAL TARGET SALES
//               </span>
//               <h3
//                 style={{
//                   margin: "8px 0 0 0",
//                   color: "#28a745",
//                   fontSize: "calc(14px + 0.6vw)",
//                   wordBreak: "break-all",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {formatIDR(summaryData.totalTargetSales)}
//               </h3>
//             </div>

//             {/* CARD 3: AVG PERCENTAGE */}
//             <div
//               style={{
//                 background: "#f8f9fa",
//                 padding: "16px",
//                 borderRadius: "6px",
//                 borderRight: "6px solid #ffc107",
//                 boxSizing: "border-box", // Diperbaiki dari boxShaping
//                 boxShadow:
//                   "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
//               }}
//             >
//               <span
//                 style={{
//                   display: "block",
//                   fontSize: "12px",
//                   color: "#6c757d",
//                   fontWeight: "600",
//                   letterSpacing: "0.5px",
//                 }}
//               >
//                 TOTAL AVG PERCENTAGE
//               </span>
//               <h3
//                 style={{
//                   margin: "8px 0 0 0",
//                   color: "#ffc107",
//                   fontSize: "calc(16px + 0.6vw)",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {summaryData.avgPercentage?.toFixed(2)}%
//               </h3>
//             </div>
//           </div>

//           {/* 2. PANEL BREAKDOWN PER INDIVIDU CLIENT (DENGAN SCROLL HORIZONTAL DI HP AGAR TIDAK CAUR) */}
//           <div
//             style={{
//               background: "#f8f9fa",
//               borderRadius: "8px",
//               border: "1px solid #e3e6f0",
//               padding: "16px",
//               boxShaping: "border-box",
//               width: "100%",
//             }}
//           >
//             <div
//               style={{
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 color: "#000000",
//                 marginBottom: "12px",
//                 textTransform: "uppercase",
//               }}
//             >
//               Breakdown Realisasi dan Target Per BPD Client ({selectedTahun})
//             </div>

//             {/* Container pembungkus tabel agar di HP bisa di-swipe kanan-kiri secara halus tanpa merusak layout luar layout dashboard */}
//             <div
//               style={{
//                 overflowX: "auto",
//                 WebkitOverflowScrolling: "touch",
//                 width: "100%",
//                 borderRadius: "4px",
//                 border: "1px solid #e3e6f0", // Opsional: memberi border tipis di luar tabel agar rapi
//               }}
//             >
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   textAlign: "left",
//                   fontSize: "14px",
//                   // Kita set minWidth ke 700px agar saat di HP space teks angka milyaran tetap aman tidak patah baris
//                   minWidth: "700px",
//                   tableLayout: "fixed", // KUNCI UTAMA: Memaksa browser mengikuti lebar th yang kita tentukan
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       borderBottom: "2px solid #e3e6f0",
//                       color: "#495057",
//                       background: "#eaecf4",
//                     }}
//                   >
//                     {/* Mengatur distribusi lebar kolom secara proporsional */}
//                     <th style={{ padding: "12px", width: "25%" }}>
//                       Nama Client BPD
//                     </th>
//                     <th style={{ padding: "12px", width: "30%" }}>
//                       Total Target Sales
//                     </th>
//                     <th style={{ padding: "12px", width: "30%" }}>
//                       Total Disbursement
//                     </th>
//                     <th
//                       style={{
//                         padding: "12px",
//                         width: "15%",
//                         textAlign: "right",
//                       }}
//                     >
//                       Pencapaian
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {clientSummaryList.map((item, index) => (
//                     <tr
//                       key={item.client}
//                       style={{
//                         borderBottom: "1px solid #e3e6f0", // Mengubah 3px ke 1px agar border antar baris tidak terlalu tebal kaku
//                         background: index % 2 === 0 ? "#ffffff" : "#fdfdfe", // Mengubah % 4 ke % 2 agar belang-belang row-nya konsisten selang-seling
//                       }}
//                     >
//                       <td
//                         style={{
//                           padding: "12px",
//                           fontWeight: "600",
//                           color: "#424242",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         {item.client}
//                       </td>
//                       <td
//                         style={{
//                           padding: "12px",
//                           color: "#09a46b",
//                           fontWeight: "500",
//                         }}
//                       >
//                         {formatIDR(item.totalTargetSales)}
//                       </td>
//                       <td
//                         style={{
//                           padding: "12px",
//                           color: "#4e73df",
//                           fontWeight: "500",
//                         }}
//                       >
//                         {formatIDR(item.totalDisbursement)}
//                       </td>
//                       <td
//                         style={{
//                           padding: "12px",
//                           textAlign: "right",
//                           fontWeight: "bold",
//                           color:
//                             item.avgPercentage >= 100 ? "#1cc88a" : "#fcbb16",
//                         }}
//                       >
//                         {item.avgPercentage.toFixed(2)}%
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* VISUALISASI GRAPH MULTI-SERIES AREA */}
//       {loading ? (
//         <div style={{ padding: "40px", textAlign: "center" }}>
//           <strong>Loading Data Dashboard Kompleks...</strong>
//         </div>
//       ) : chartSeries.length > 0 ? (
//         <Chart
//           options={chartOptions}
//           series={chartSeries}
//           type="area" // Mengubah tipe dasar render global menjadi Area Chart murni berlapis
//           height="450"
//         />
//       ) : (
//         <div style={{ padding: "40px", textAlign: "center", color: "#888" }}>
//           Data kosong pada tahun {selectedTahun}.
//         </div>
//       )}
//     </div>
//   );
// }

// export default DashboardDisbursement;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Chart from "react-apexcharts/dist/react-apexcharts.min.js";
import { getDashboardExcel } from "stores";
import "./DashboardDisbursement.css";

const partnershipStart = {
  "BPD KALTIMTARA": "Mei 2023",
  "BPD KALTENG": "Juni 2021",
  "BPD KALSEL": "Mei 2022",
  "BPD SULUTGO": "Juni 2023",
  "BPD KALBAR": "Februari 2026",
};

const achievementClass = (percentage) =>
  percentage >= 100 ? "achieved" : percentage < 50 ? "low" : "progress";

function DashboardDisbursement() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);

  const currentYear = new Date().getFullYear();

  const generateInitialYears = () => {
    const startYear = 2022;
    const years = [];
    for (let y = currentYear; y >= startYear; y--) {
      years.push(y);
    }
    return years.sort((a, b) => a - b);
  };

  // State Utama Filter & Data
  const [selectedTahun, setSelectedTahun] = useState(currentYear);
  const [selectedClient, setSelectedClient] = useState("All");
  const [listTahun, setListTahun] = useState(generateInitialYears());

  // State untuk menyimpan data series Chart
  const [chartSeries, setChartSeries] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [clientSummaryList, setClientSummaryList] = useState([]);

  // STATE MASTER: Menyimpan semua data mentah tahun terpilih untuk disajikan ke tabel-tabel bawah
  const [rawYearlyData, setRawYearlyData] = useState([]);

  // Master Data Client & Bulan
  const listClientMaster = [
    "BPD KALTIMTARA",
    "BPD KALTENG",
    "BPD KALSEL",
    "BPD SULUTGO",
    "BPD KALBAR",
  ];

  const monthsFull = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const monthsName = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agu",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ];

  useEffect(() => {
    setLoading(true);

    // KUNCI UTAMA: API ke backend SELALU meminta data "All" client agar data 5 BPD selalu lengkap ter-load
    getDashboardExcel(dispatch, {
      tahun: selectedTahun,
      client: "All", // Di-lock ke "All" untuk kebutuhan tabel-tabel resume bawah
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        console.log("RAW DATA SETAHUN ALL CLIENT:", response);

        if (response && response.data) {
          if (response.summary) {
            setSummaryData(response.summary);
          }

          // Simpan data murni semua client untuk 6 tabel mandiri bawah (Hanya bergantung filter Tahun!)
          setRawYearlyData(response.data);

          // Sinkronisasi dropdown list tahun
          const availableYears = response.data.map((item) =>
            Number(item.tahun),
          );
          const mergedYears = [...listTahun, ...availableYears];
          const uniqueYears = [...new Set(mergedYears)].sort((a, b) => a - b);
          if (uniqueYears.length > 0) setListTahun(uniqueYears);

          // ====================================================================
          // LOGIKA SUMMARY BOX (Card Atas) - Menyesuaikan Pilihan Dropdown Client
          // ====================================================================
          const clientsToProcess =
            selectedClient === "All" ? listClientMaster : [selectedClient];

          const breakdownResult = clientsToProcess.map((bpdName) => {
            const bpdData = response.data.filter(
              (item) => item.client === bpdName,
            );
            const totalDisbursement = bpdData.reduce(
              (sum, item) => sum + Number(item.disbursement || 0),
              0,
            );
            const totalTargetSales = bpdData.reduce(
              (sum, item) => sum + Number(item.target_sales || 0),
              0,
            );
            const avgPercentage =
              totalTargetSales > 0
                ? (totalDisbursement / totalTargetSales) * 100
                : 0;

            return {
              client: bpdName,
              totalDisbursement,
              totalTargetSales,
              avgPercentage,
            };
          });
          setClientSummaryList(breakdownResult);

          // ====================================================================
          // LOGIKA GRAFIK AREA - DI-FILTER DI FRONTEND MENGIKUTI DROPDOWN CLIENT
          // ====================================================================
          const finalSeries = [];

          if (selectedClient === "All") {
            // Garis TOTAL ALL Gabungan
            const totalAllArray = Array(12).fill(0);
            response.data.forEach((item) => {
              const mIdx = parseInt(item.bulan, 10) - 1;
              if (mIdx >= 0 && mIdx < 12) {
                totalAllArray[mIdx] += Number(item.disbursement || 0);
              }
            });
            finalSeries.push({ name: "TOTAL ALL", data: totalAllArray });

            // Garis masing-masing 5 BPD
            listClientMaster.forEach((bpd) => {
              const bpdArray = Array(12).fill(0);
              const bpdFilteredData = response.data.filter(
                (item) => item.client === bpd,
              );
              bpdFilteredData.forEach((item) => {
                const mIdx = parseInt(item.bulan, 10) - 1;
                if (mIdx >= 0 && mIdx < 12) {
                  bpdArray[mIdx] = Number(item.disbursement || 0);
                }
              });
              finalSeries.push({ name: bpd, data: bpdArray });
            });
          } else {
            // Jika user memilih salah satu client (Misal: BPD KALTENG), grafik hanya render 1 garis tersebut
            const singleBpdArray = Array(12).fill(0);
            // Memfilter data dari raw response murni di frontend
            const singleBpdFiltered = response.data.filter(
              (item) => item.client === selectedClient,
            );

            singleBpdFiltered.forEach((item) => {
              const mIdx = parseInt(item.bulan, 10) - 1;
              if (mIdx >= 0 && mIdx < 12) {
                singleBpdArray[mIdx] = Number(item.disbursement || 0);
              }
            });
            finalSeries.push({
              name: `Disbursement (${selectedClient})`,
              data: singleBpdArray,
            });
          }

          setChartSeries(finalSeries);
        }
      })
      .catch((err) => {
        console.error(err);
        setChartSeries([]);
        setClientSummaryList([]);
        setRawYearlyData([]);
      })
      .finally(() => setLoading(false));

    // State selectedClient tetap dimasukkan sebagai dependency agar grafik langsung merespon perubahan dropdown tanpa hit ulang API
  }, [selectedTahun, selectedClient, dispatch]);

  //   useEffect(() => {
  //     setLoading(true);

  //     getDashboardExcel(dispatch, {
  //       tahun: selectedTahun,
  //       client: selectedClient,
  //       page: 1,
  //       limit: 1000,
  //     })
  //       .then((response) => {
  //         console.log("RAW DATA DARI BACKEND:", response);

  //         if (response && response.data) {
  //           if (response.summary) {
  //             setSummaryData(response.summary);
  //           }

  //           // Simpan data tahunan untuk kalkulasi tabel-tabel mandiri bawah
  //           setRawYearlyData(response.data);

  //           // Sinkronisasi dropdown list tahun
  //           const availableYears = response.data.map((item) =>
  //             Number(item.tahun),
  //           );
  //           const mergedYears = [...listTahun, ...availableYears];
  //           const uniqueYears = [...new Set(mergedYears)].sort((a, b) => a - b);
  //           if (uniqueYears.length > 0) setListTahun(uniqueYears);

  //           // ====================================================================
  //           // LOGIKA: KALKULASI BREAKDOWN SUMMARY PER CLIENT DARI DATABASE
  //           // ====================================================================
  //           const clientsToProcess =
  //             selectedClient === "All" ? listClientMaster : [selectedClient];

  //           const breakdownResult = clientsToProcess.map((bpdName) => {
  //             const bpdData = response.data.filter(
  //               (item) => item.client === bpdName,
  //             );

  //             const totalDisbursement = bpdData.reduce(
  //               (sum, item) => sum + Number(item.disbursement || 0),
  //               0,
  //             );
  //             const totalTargetSales = bpdData.reduce(
  //               (sum, item) => sum + Number(item.target_sales || 0),
  //               0,
  //             );
  //             const avgPercentage =
  //               totalTargetSales > 0
  //                 ? (totalDisbursement / totalTargetSales) * 100
  //                 : 0;

  //             return {
  //               client: bpdName,
  //               totalDisbursement,
  //               totalTargetSales,
  //               avgPercentage,
  //             };
  //           });

  //           setClientSummaryList(breakdownResult);

  //           // Logika pembentukan grafik area (KEMBALI KE ASLI TANPA DIUBAH-UBAH SUMBU Y-NYA)
  //           const finalSeries = [];
  //           if (selectedClient === "All") {
  //             const totalAllArray = Array(12).fill(0);
  //             response.data.forEach((item) => {
  //               const mIdx = parseInt(item.bulan, 10) - 1;
  //               if (mIdx >= 0 && mIdx < 12) {
  //                 totalAllArray[mIdx] += Number(item.disbursement || 0);
  //               }
  //             });
  //             finalSeries.push({ name: "TOTAL ALL", data: totalAllArray });

  //             listClientMaster.forEach((bpd) => {
  //               const bpdArray = Array(12).fill(0);
  //               const bpdFilteredData = response.data.filter(
  //                 (item) => item.client === bpd,
  //               );
  //               bpdFilteredData.forEach((item) => {
  //                 const mIdx = parseInt(item.bulan, 10) - 1;
  //                 if (mIdx >= 0 && mIdx < 12) {
  //                   bpdArray[mIdx] = Number(item.disbursement || 0);
  //                 }
  //               });
  //               finalSeries.push({ name: bpd, data: bpdArray });
  //             });
  //           } else {
  //             const singleBpdArray = Array(12).fill(0);
  //             response.data.forEach((item) => {
  //               const mIdx = parseInt(item.bulan, 10) - 1;
  //               if (mIdx >= 0 && mIdx < 12) {
  //                 singleBpdArray[mIdx] = Number(item.disbursement || 0);
  //               }
  //             });
  //             finalSeries.push({
  //               name: `Disbursement (${selectedClient})`,
  //               data: singleBpdArray,
  //             });
  //           }
  //           setChartSeries(finalSeries);
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         setChartSeries([]);
  //         setClientSummaryList([]);
  //         setRawYearlyData([]);
  //       })
  //       .finally(() => setLoading(false));
  //   }, [selectedTahun, selectedClient, dispatch]);

  const formatIDR = (val) => "Rp " + Number(val || 0).toLocaleString("id-ID");

  // Helper ringkas khusus sel tabel biar layout excelnya tidak melebar caur
  const formatTableIDR = (val) => {
    if (!val || val === 0) return "0";
    return Number(val).toLocaleString("id-ID");
  };

  // Konfigurasi Khusus Multi-Series Area Chart ASLI milikmu
  const chartOptions = {
    chart: {
      id: "area-disbursement-chart",
      type: "area",
      toolbar: { show: true },
      zoom: { enabled: true },
    },
    xaxis: {
      categories: monthsName,
      title: { text: "Bulan" },
    },
    yaxis: {
      title: { text: "Nominal Disbursement (IDR)" },
      labels: {
        formatter: (value) => {
          if (value >= 1e12) return (value / 1e12).toFixed(1) + " T";
          if (value >= 1e9) return (value / 1e9).toFixed(1) + " Miliar";
          if (value >= 1e6) return (value / 1e6).toFixed(1) + " Jt";
          return value;
        },
      },
    },
    fill: {
      type: "vertical",
      opacity:
        selectedClient === "All" ? [0.05, 0.2, 0.2, 0.2, 0.2, 0.2] : [0.3],
    },
    stroke: {
      width: selectedClient === "All" ? [5, 2.5, 2.5, 2.5, 2.5, 2.5] : [3.5],
      curve: "smooth",
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => formatIDR(val),
      },
    },
    colors: ["#20c997", "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"],
    dataLabels: { enabled: false },
    legend: { position: "top" },
  };

  // ====================================================================
  // LOGIKA UTILITY UNTUK FILTER DATA MATANG PER CLIENT PER BULAN
  // ====================================================================
  const getClientRowData = (bpdName, monthIdx) => {
    const match = rawYearlyData.find(
      (item) =>
        item.client === bpdName && parseInt(item.bulan, 10) === monthIdx + 1,
    );
    const target = match ? Number(match.target_sales || 0) : 0;
    const disbursement = match ? Number(match.disbursement || 0) : 0;
    const percentage = target > 0 ? (disbursement / target) * 100 : 0;

    return { target, disbursement, percentage };
  };

  const getClientGrandTotal = (bpdName) => {
    const bpdItems = rawYearlyData.filter((item) => item.client === bpdName);
    const totalTarget = bpdItems.reduce(
      (sum, item) => sum + Number(item.target_sales || 0),
      0,
    );
    const totalDisburse = bpdItems.reduce(
      (sum, item) => sum + Number(item.disbursement || 0),
      0,
    );
    const totalPercent =
      totalTarget > 0 ? (totalDisburse / totalTarget) * 100 : 0;

    return { totalTarget, totalDisburse, totalPercent };
  };

  const getTotalAllRowData = (monthIdx) => {
    const monthItems = rawYearlyData.filter(
      (item) => parseInt(item.bulan, 10) === monthIdx + 1,
    );
    const target = monthItems.reduce(
      (sum, item) => sum + Number(item.target_sales || 0),
      0,
    );
    const disbursement = monthItems.reduce(
      (sum, item) => sum + Number(item.disbursement || 0),
      0,
    );
    const percentage = target > 0 ? (disbursement / target) * 100 : 0;

    return { target, disbursement, percentage };
  };

  const getTotalAllGrandTotal = () => {
    const totalTarget = rawYearlyData.reduce(
      (sum, item) => sum + Number(item.target_sales || 0),
      0,
    );
    const totalDisburse = rawYearlyData.reduce(
      (sum, item) => sum + Number(item.disbursement || 0),
      0,
    );
    const totalPercent =
      totalTarget > 0 ? (totalDisburse / totalTarget) * 100 : 0;

    return { totalTarget, totalDisburse, totalPercent };
  };
  // ====================================================================
  React.useEffect(() => {
    if (auth.role === "super admin") {
      const interval = setInterval(() => {
        window.location.reload();
        refresh();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [auth.role]);

  return (
    <div
      className="disbursement-dashboard"
      style={{
        padding: "clamp(12px, 2vw, 24px)",
        minWidth: 0,
        background: "#fff",
        borderRadius: "8px",
        boxSizing: "border-box",
      }}
    >
      <h2 style={{ fontWeight: "bold", textAlign: "center" }}>
        Dashboard Disbursement All BPD - Tahun {selectedTahun}
      </h2>
      <hr
        style={{
          border: "none",
          height: "3px",
          backgroundColor: "black",
          maxWidth: "950px",
          margin: "20px auto",
        }}
      />

      {/* SECTION DROPDOWN FILTER */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "bold",
            }}
          >
            Tahun:
          </label>
          <select
            value={selectedTahun}
            onChange={(e) => setSelectedTahun(Number(e.target.value))}
            style={{
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            {listTahun.map((th) => (
              <option key={th} value={th}>
                {th}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "bold",
            }}
          >
            Client:
          </label>
          <select
            value={selectedClient}
            onChange={(e) => setSelectedClient(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              minWidth: "200px",
              cursor: "pointer",
            }}
          >
            {["All", ...listClientMaster].map((cli) => (
              <option key={cli} value={cli}>
                {cli}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* SUMMARY BANNER CARD */}
      {summaryData && clientSummaryList.length > 0 && (
        <div style={{ marginBottom: "32px", width: "100%" }}>
          {/* 1. KOTAK GRAND TOTAL UTAMA */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "20px",
              marginBottom: "24px",
              width: "100%",
            }}
          >
            {/* CARD 1: TARGET SALES */}
            <div
              style={{
                background: "#f8f9fa",
                padding: "16px",
                borderRadius: "6px",
                borderRight: "6px solid #28a745",
                boxSizing: "border-box",
                boxShadow:
                  "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <span
                style={{
                  display: "block",
                  fontSize: "12px",
                  color: "#6c757d",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                GRAND TOTAL TARGET SALES
              </span>
              <h3
                style={{
                  margin: "8px 0 0 0",
                  color: "#28a745",
                  fontSize: "calc(14px + 0.6vw)",
                  wordBreak: "break-all",
                  fontWeight: "bold",
                }}
              >
                {formatIDR(summaryData.totalTargetSales)}
              </h3>
            </div>

            {/* CARD 2: DISBURSEMENT */}
            <div
              style={{
                background: "#f8f9fa",
                padding: "16px",
                borderRadius: "6px",
                borderRight: "6px solid #007bff",
                boxSizing: "border-box",
                boxShadow:
                  "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <span
                style={{
                  display: "block",
                  fontSize: "12px",
                  color: "#6c757d",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                GRAND TOTAL DISBURSEMENT
              </span>
              <h3
                style={{
                  margin: "8px 0 0 0",
                  color: "#007bff",
                  fontSize: "calc(14px + 0.6vw)",
                  wordBreak: "break-all",
                  fontWeight: "bold",
                }}
              >
                {formatIDR(summaryData.totalDisbursement)}
              </h3>
            </div>

            {/* CARD 3: AVG PERCENTAGE (DENGAN TERNARY DYNAMIC COLOR) */}
            <div
              style={{
                background: "#f8f9fa",
                padding: "16px",
                borderRadius: "6px",
                // Border kanan juga ikut berubah dinamis mengikuti status persentase
                borderRight: `6px solid ${
                  summaryData.avgPercentage >= 100
                    ? "#09a46b"
                    : summaryData.avgPercentage < 50
                      ? "#dc3545"
                      : "#ffc107"
                }`,
                boxSizing: "border-box",
                boxShadow:
                  "5px 5px 10px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <span
                style={{
                  display: "block",
                  fontSize: "12px",
                  color: "#6c757d",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                TOTAL AVG PERCENTAGE
              </span>
              <h3
                style={{
                  margin: "8px 0 0 0",
                  fontSize: "calc(16px + 0.6vw)",
                  fontWeight: "bold",
                  // TERNARY WARNA TEXT ANGKA UTAMA
                  color:
                    summaryData.avgPercentage >= 100
                      ? "#09a46b" // Hijau target sales
                      : summaryData.avgPercentage < 50
                        ? "#dc3545" // Merah jika di bawah 50%
                        : "#ffc107", // Kuning jika di antara 50% - 99.9%
                }}
              >
                {summaryData.avgPercentage?.toFixed(2)}%
              </h3>
            </div>
          </div>

          {/* TABLE PANEL 1: BREAKDOWN TARGET VS REALISASI ATAS */}
          <div
            style={{
              background: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e3e6f0",
              padding: "16px",
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#000000",
                marginBottom: "12px",
                textTransform: "uppercase",
              }}
            >
              Breakdown Realisasi dan Target Per BPD Client ({selectedTahun})
            </div>
            <div
              style={{
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                width: "100%",
                borderRadius: "4px",
                border: "1px solid #e3e6f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "left",
                  fontSize: "14px",
                  minWidth: "700px",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr
                    style={{
                      borderBottom: "2px solid #e3e6f0",
                      color: "#495057",
                      background: "#eaecf4",
                    }}
                  >
                    <th style={{ padding: "12px", width: "25%" }}>
                      Nama Client BPD
                    </th>
                    <th style={{ padding: "12px", width: "30%" }}>
                      Total Target Sales
                    </th>
                    <th style={{ padding: "12px", width: "30%" }}>
                      Total Disbursement
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        width: "15%",
                        textAlign: "right",
                      }}
                    >
                      Pencapaian
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {clientSummaryList.map((item, index) => (
                    <tr
                      key={item.client}
                      style={{
                        borderBottom: "1px solid #e3e6f0",
                        background: index % 2 === 0 ? "#ffffff" : "#fdfdfe",
                      }}
                    >
                      <td
                        style={{
                          padding: "12px",
                          fontWeight: "600",
                          color: "#424242",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.client}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          color: "#09a46b",
                          fontWeight: "500",
                        }}
                      >
                        {formatIDR(item.totalTargetSales)}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          color: "#4e73df",
                          fontWeight: "700",
                        }}
                      >
                        {formatIDR(item.totalDisbursement)}
                      </td>
                      {/* KOLOM PENCAPAIAN DENGAN REKAYASA TERNARY BARU */}
                      <td
                        style={{
                          padding: "12px",
                          textAlign: "right",
                          fontWeight: "bold",
                          // TERNARY WARNA ANGKA PERSENTASE DI TABEL BARIS
                          color:
                            item.avgPercentage >= 100
                              ? "#09a46b" // Hijau terang target sales
                              : item.avgPercentage < 50
                                ? "#dc3545" // Merah kritis
                                : "#ffc107", // Kuning standar
                        }}
                      >
                        {item.avgPercentage.toFixed(2)}%
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* VISUALISASI GRAPH MULTI-SERIES AREA ASLI */}
      <div style={{ marginBottom: "32px" }}>
        {loading ? (
          <div style={{ padding: "40px", textAlign: "center" }}>
            <strong>Loading Data Dashboard Kompleks...</strong>
          </div>
        ) : chartSeries.length > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="area"
            height="450"
          />
        ) : (
          <div style={{ padding: "40px", textAlign: "center", color: "#888" }}>
            Data kosong pada tahun {selectedTahun}.
          </div>
        )}
      </div>

      {!loading && rawYearlyData.length > 0 && (
        <section className="disbursement-recap" aria-labelledby="recap-title">
          <header className="disbursement-recap__heading">
            <div>
              <span className="disbursement-recap__eyebrow">
                LAPORAN BULANAN
              </span>
              <h3 id="recap-title">Rekapitulasi per Client BPD</h3>
              <p>Target sales, disbursement, dan pencapaian setiap bulan.</p>
            </div>
            <span className="disbursement-recap__year">
              Tahun {selectedTahun}
            </span>
          </header>
          <p className="disbursement-recap__hint" id="recap-hint">
            Nominal dalam Rupiah (Rp). Geser tabel ke samping jika diperlukan.
          </p>

          <div className="disbursement-recap__grid">
            {[...listClientMaster, "TOTAL ALL (GABUNGAN)"].map((bpd, index) => {
              const isTotal = bpd === "TOTAL ALL (GABUNGAN)";
              const totals = isTotal
                ? getTotalAllGrandTotal()
                : getClientGrandTotal(bpd);
              const titleId = `recap-bank-${index}`;

              return (
                <article
                  key={bpd}
                  className={`disbursement-recap__card${isTotal ? " disbursement-recap__card--total" : ""}`}
                  aria-labelledby={titleId}
                >
                  <header className="disbursement-recap__bank-header">
                    <h4 id={titleId}>{bpd}</h4>
                    <span className="disbursement-recap__badge">
                      {isTotal
                        ? "Rekap seluruh BPD"
                        : `Kerjasama ${partnershipStart[bpd]}`}
                    </span>
                  </header>
                  <div
                    className="disbursement-recap__scroll"
                    role="region"
                    aria-labelledby={titleId}
                    aria-describedby="recap-hint"
                    tabIndex={0}
                  >
                    <table
                      className="disbursement-recap__table"
                      aria-label={`${bpd} tahun ${selectedTahun}`}
                    >
                      <thead>
                        <tr>
                          <th scope="col" className="disbursement-recap__number">No</th>
                          <th scope="col" className="disbursement-recap__month">Bulan</th>
                          <th scope="col">Target Sales</th>
                          <th scope="col">Disbursement</th>
                          <th scope="col">Capaian (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {monthsFull.map((monthName, mIdx) => {
                          const row = isTotal
                            ? getTotalAllRowData(mIdx)
                            : getClientRowData(bpd, mIdx);
                          return (
                            <tr key={monthName}>
                              <td className="disbursement-recap__number">
                                {mIdx + 1}
                              </td>
                              <th scope="row" className="disbursement-recap__month">
                                {monthName}
                              </th>
                              <td>{formatTableIDR(row.target)}</td>
                              <td className="disbursement-recap__amount">
                                {formatTableIDR(row.disbursement)}
                              </td>
                              <td>
                                <span
                                  className={`disbursement-recap__percentage disbursement-recap__percentage--${achievementClass(row.percentage)}`}
                                >
                                  {row.percentage.toFixed(1)}%
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="row" colSpan={2}>Grand Total</th>
                          <td>{formatTableIDR(totals.totalTarget)}</td>
                          <td className="disbursement-recap__amount">
                            {formatTableIDR(totals.totalDisburse)}
                          </td>
                          <td>
                            <span
                              className={`disbursement-recap__percentage disbursement-recap__percentage--${achievementClass(totals.totalPercent)}`}
                            >
                              {totals.totalPercent.toFixed(1)}%
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      )}
      {/* ==================================================================== */}
    </div>
  );
}

export default DashboardDisbursement;
